<template>
    <form-wrapper class="account-information-form" @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.change_password.fields.old_password.label')"
                    :placeholder="$t('forms.change_password.fields.old_password.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    type="password"
                    valuePath="currentPassword"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.change_password.fields.new_password.label')"
                    :placeholder="$t('forms.change_password.fields.new_password.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    type="password"
                    valuePath="newPassword"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.change_password.fields.repeat_password.label')"
                    :placeholder="$t('forms.change_password.fields.repeat_password.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    :error="passwordRepeatError"
                    type="password"
                    valuePath="repeatPassword"
                    @change="repeatPasswordChange($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('forms.change_password.buttons.cancel')"
                    :isSubmittable="false"
                    type="secondary"
                    size="large"
                    @click="emitEvent({ name: 'cancel' })"
                ></common-button>
                <common-button :label="$t('forms.change_password.buttons.save')" size="large" type="primary"></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import AuthAPI from 'api/AuthAPI'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [FormMixin, HandleRequestMixin, ScreenSizeDetectionMixin],

        data() {
            return {
                passwordRepeatError: '',
            }
        },

        methods: {
            handleFormSubmission(data) {
                if (data.newPassword !== data.repeatPassword) {
                    return (this.passwordRepeatError = this.$t('forms.change_password.not_matching'))
                }
                this.handleRequest(AuthAPI.changePassword(data.currentPassword, data.newPassword), {
                    email: data.email,
                })
                    .then(() => {
                        this.emitEvent({ name: 'success' })
                    })
                    .catch(() => {})
            },

            repeatPasswordChange(event) {
                this.passwordRepeatError = ''
                this.change(event)
            },
        },
    }
</script>
